import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=420133a4&scoped=true&"
import script from "./tree-item.vue?vue&type=script&lang=js&"
export * from "./tree-item.vue?vue&type=script&lang=js&"
import style0 from "./tree-item.vue?vue&type=style&index=0&id=420133a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420133a4",
  null
  
)

component.options.__file = "tree-item.vue"
export default component.exports